import React, { useState, useEffect, Fragment } from "react";
import firebase from "../../../firebase";
import "firebase/firestore";

import { Paper, Grid } from "@material-ui/core";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";

import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";

import { Button } from "@material-ui/core";
import { Download } from "../../ExcelExport";
import TablaResultados from "./tablaResultados";

const db = firebase.firestore();

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Dashboard = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const [startDate, setStartDate] = useState(
    new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(new Date());
  const [empresas, setEmpresas] = useState(
    props.user && props.user.empresa ? [props.user.empresa] : []
  );

  const [establecimientos, setEstablecimientos] = useState([]);

  const [registros, setRegistros] = useState([]);

  useEffect(() => {
    db.collection("empresas").onSnapshot(function (querySnapshot) {
      let documentos = [];
      querySnapshot.forEach((d) => {
        documentos.push({
          ...d.data(),
          id: d.id,
        });
      });
      setEstablecimientos(documentos);
    });
  }, []);

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const buscarRegistros = async () => {
    if (empresas.length > 0) {
      let start = new Date(startDate);
      start.setHours(0);
      let end = new Date(endDate);
      start.setHours(23);

      db.collection("registros")
        .where("empresa", "in", empresas)
        .where("nacimiento", ">=", start)
        .where("nacimiento", "<=", end)
        .onSnapshot(function (querySnapshot) {
          let documentos = [];
          querySnapshot.forEach((d) => {
            documentos.push({
              ...d.data(),
              id: d.id,
            });
          });
          setRegistros(documentos);
        });
    }
  };

  const handleChange = (event) => {
    setEmpresas(event.target.value);
  };

  return (
    <Paper
      style={{
        margin: "4%",
        minHeight: "400px",
      }}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justify="space-around">
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="Fecha Inicial"
            format="dd/MM/yyyy"
            value={startDate}
            maxDate={new Date()}
            onChange={handleStartDate}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="Fecha Final"
            format="dd/MM/yyyy"
            value={endDate}
            maxDate={new Date()}
            onChange={handleEndDate}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </Grid>
        {props.user.rol === "superadmin" && establecimientos.length > 0 && (
          <Fragment>
            <Grid container justify="center" style={{ minHeight: "80px" }}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-mutiple-checkbox-label">
                  Establecimientos
                </InputLabel>
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  multiple
                  value={empresas}
                  onChange={handleChange}
                  input={<Input />}
                  renderValue={(selected) =>
                    selected
                      .map((v) =>
                        establecimientos.find((e) => e.id === v)
                          ? establecimientos.find((e) => e.id === v).name
                          : ""
                      )
                      .join(", ")
                  }
                  MenuProps={MenuProps}
                >
                  {establecimientos.map((e) => (
                    <MenuItem key={e.id} value={e.id}>
                      <Checkbox checked={empresas.indexOf(e.id) > -1} />
                      <ListItemText primary={e.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Fragment>
        )}

        <Grid container justify="center">
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => buscarRegistros()}
          >
            Buscar
          </Button>
        </Grid>
        {registros.length > 0 && (
          <Grid
            container
            justify="center"
            style={{
              marginTop: "30px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TablaResultados
              registros={registros.map((r) => {
                return {
                  id: r.id,
                  nacimiento: r.nacimiento.toDate(),
                  fecha: r.fecha.toDate(),
                  establecimiento: establecimientos.find(
                    (e) => e.id === r.empresa
                  )
                    ? establecimientos.find((e) => e.id === r.empresa).name
                    : "",
                  sexo: r.sexo,
                  raza: r.raza,
                  color: r.color,
                  peso: r.peso,
                  rpcria: r.rpcria,
                  rpmadre: r.rpmadre,
                  padre: r.padre,
                  tregistro: r.tregistro,
                  observaciones: r.observaciones,
                };
              })}
            />

            <Download
              dataSet={registros.map((r) => {
                return {
                  nacimiento: r.nacimiento.toDate(),
                  fecha: r.fecha.toDate(),
                  establecimiento: establecimientos.find(
                    (e) => e.id === r.empresa
                  )
                    ? establecimientos.find((e) => e.id === r.empresa).name
                    : "",
                  sexo: r.sexo,
                  raza: r.raza,
                  color: r.color,
                  peso: r.peso,
                  rpcria: r.rpcria,
                  rpmadre: r.rpmadre,
                  padre: r.padre,
                  tregistro: r.tregistro,
                  observaciones: r.observaciones,
                };
              })}
            />
          </Grid>
        )}
      </MuiPickersUtilsProvider>
    </Paper>
  );
};

export default Dashboard;
